import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DepositRatesDTO } from '../../interfaces/depositRates';

const initialState = [];

const depositRatesSlice = createSlice({
  name: 'depositRates',
  initialState,
  reducers: {
    setDepositRates: (_, action: PayloadAction<DepositRatesDTO['data']>) => {
      return action.payload;
    },
  },
});

const { actions, reducer } = depositRatesSlice;

export const { setDepositRates } = actions;

export default reducer;
